<template>
  <div class="animated fadeIn new__card__container">
    <b-modal
      ref="modal-newlead"
      scrollable
      centered
      @hide="hideModal"
      @close="hideModal"
    >
      <RestrictionAlert :personDocument="pessoa.document" />
      <template #modal-title>
        <i class="fas fa-user-plus"></i> Nova Oportunidade
      </template>
      <div class="pt-2 pb-4">
        <div class="pt-2">
          <SelectBoard @onSelect="loadColumns" :onlyActive="true" />
        </div>
        <div class="pt-2">
          <SelectBoardColumn
            v-if="boardId"
            @onSelect="saveBoardAndColumn"
            :boardId="boardId"
            :key="boardId"
          />
        </div>
        <div class="pt-2">
          <SelectOrigem v-if="boardColumnId" @onSelect="saveOrigin"/>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            @click.prevent="onSave"
            type="button"
            class="btn rounded btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Salvar'"
          >
            <i class="fas fa-check-circle mr-1"></i>
            <span class="d-md-down-none">Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

import CardRepository from '@/shared/http/repositories/crm/card.js'

import RestrictionAlert from '@/components//UI/restrictionAlert/restrictionAlert.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'

export default {
  name: 'ModalNewLead',
  mixins: [ActionsForm],
  data () {
    return {
      boardId: null,
      boardColumnId: null,
      originId: null
    }
  },
  components: {
    RestrictionAlert,
    SelectBoard,
    SelectBoardColumn,
    SelectOrigem
  },
  props: {
    pessoa: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.$refs['modal-newlead'].show()
  },
  methods: {
    onLoad () {},
    hideModal () {
      this.$refs['modal-newlead'].hide()
      this.$emit('closeModal')
    },
    loadColumns (boardId) {
      this.boardId = boardId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.boardId = boardAndColumn[0]
      this.boardColumnId = boardAndColumn[1]
    },
    saveOrigin (origin) {
      this.originId = origin
    },
    createData () {
      let cardData = {
        'boardColumnId': this.boardColumnId,
        'motivoPerdaId': null,
        'posicao': 0,
        'situacao': 'ATIVO',
        'countReativado': 0,
        'dataCriacao': new Date().toISOString(),
        'dataInicioSituacao': new Date().toISOString(),
        'dataReativacao': null,
        'origemLeadId': this.originId,
        'pessoaId': this.pessoa.id
      }
      return cardData
    },
    async onSave () {
      await CardRepository.Create(this.createData())
        .then((response) => {
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success, 'Nova Oportunidade')
          this.$emit('Back')
        })
        .catch((err) => {
          console.error(err, 'if')
          this.onException(err)
        })
    }
  }
}
</script>

<style lang="scss">

.new__card__container{

  .v-select > #vs1__combobox,
  .v-select > #vs2__combobox,
  .vs__dropdown-toggle {
    border-radius: 0 4px 4px 0 !important;
  }

  .v-select {
  flex: 1 1 auto;
  background: #fff
    url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
    no-repeat right 0.75rem center;
    background-size: 8px 10px;
  }

  .v-select input {
    padding: 2px 1rem;
    font-size: 13px;
    line-height: 1.25;
    background-clip: padding-box;
    color: #b0bec5;
  }

  .vs__selected-options {
    color: #607d8b;
  }

  .vs__actions {
    display: none;
  }

  #vs1__combobox,
  #vs2__combobox {
    border-radius: 0 !important;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  #vs1__listbox,
  .vs__selected {
    color: #607d8b;
    font-size: 13px;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/modal/newCard/newcard.vue